import React from 'react';
export function ContactButton() {
  return <div className="hidden lg:flex flex-shrink-0" data-id="element-84">
      <a href="/contact" className="inline-flex items-center justify-center font-semibold uppercase tracking-wider transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal focus-visible:ring-offset-2 focus-visible:ring-offset-brand-black active:scale-[0.97] active:transition-none clip-edges bg-brand-teal text-brand-white border border-transparent hover:bg-brand-teal-light px-4 py-2 text-xs gap-1.5" data-id="element-85">
        Contact Us
      </a>
    </div>;
}